<template>
  <Report
  :formDialogComponent="$options.components.RequisitionForm"
  :headers="headers"
  :filters="filters"
  title="Material Requisitions"
  route="/requisitions/"
  :defaultPagination="pagination"
  perimeter="requisitions"
  collection="requisitions"
  itemGetter="requisitions/requisition"
  :dialogOptions="dialogOptions"
  />
</template>

<script>
import Report from '@/components/Report'
import RequisitionForm from './RequisitionForm'

export default {
  name: 'RequisitionsReport',
  components: {
    Report,
    RequisitionForm
  },
  data () {
    return {
      dialogOptions: {
        maxWidth: '1264px'
      },
      pagination: {
        sortBy: 'job.number',
        descending: true,
        rowsPerPage: 50
      },
      headers: [
        {
          text: 'Job No.',
          value: 'job.number',
          sortable: true,
          sort: 'number'
        },
        {
          text: 'Job Name',
          value: 'job.name',
          sort: 'string',
          sortable: true
        },
        {
          text: 'SD',
          value: 'shopDrawing.number',
          sortable: true,
          sort: 'numString'
        },
        {
          text: 'TO',
          value: 'number',
          sortable: true,
          sort: 'numString'
        },
        {
          text: 'Subject',
          value: 'subject',
          sort: 'string',
          sortable: true
        }
      ],
      filters: [
        {
          label: 'Job',
          value: 'job',
          type: 'list',
          returnObject: true,
          itemValue: 'id',
          itemText: 'name'
        },
        {
          label: 'Shop Drawing',
          value: 'shopDrawing',
          type: 'list',
          returnObject: true,
          itemValue: 'id',
          itemText: 'subject'
        }
      ]
    }
  },
  computed: {},
  watch: {},
  methods: {},
  created () {}
}
</script>

<style>
</style>
